(function (Drupal, once) {

  'use strict';

  Drupal.behaviors.ajaxBlock = {
    attach(context) {
      once('ajaxBlock', '.ajax-block', context).forEach(function (element) {
        const blockId = element.dataset.blockId;

        fetch('/api/ajax/block/' + blockId)
          .then((response) => response.json())
          .then((data) => {
            if (typeof data !== 'string' || !data.length) {
              return;
            }
            const wrapper = document.createElement('div');
            wrapper.innerHTML = data;
            const newElement = wrapper.firstElementChild;
            if (!newElement) {
              return;
            }
            element.replaceWith(newElement);

            Drupal.attachBehaviors(document, Drupal.settings);
          })
          .catch((error) => {
            console.error('Ajax block load error:', error);
          });
      });
    },
  };
})(Drupal, once);
